import { KeyValuePair } from './KeyValuePair';
import { BaseSensor }  from './BaseSensor';
import { ISensorInterface } from './ISensorInterface';
import { HeatingCircuit } from './HeatingCircuit';
import { ZoneData } from './ZoneData';
import { Device } from './Device';
import { SimulatorConfig } from './SimulatorConfig';
import { SimulatorHooks } from './SimulatorHooks';
import { TranslationService } from '../services/translation.service';
export class DeviceInfo extends Device{

	private _debug:boolean=false;
	private debug(msg:string){
		if(this._debug){
			console.log("DeviceInfo: "+msg);
		}
	}
	_hooks:SimulatorHooks;	
	mode:string="";
	heatpumpCount=0;
	modes:Map<string,string>;

	states:Map<string,string>;
	_brightness: BaseSensor;
	
	getControlledZoneId(){
		let di = this;
		let zoneIds = di.getZoneIds();
		for(let zoneId of zoneIds){
			let zone = di.getZoneById(zoneId);
			if(zone.getRawValue('zone_assignment') == 'ENUM_ZONE_BINDING_CENTRAL_CONTROL'){
				return zoneId;
			}
		}
	}
	private defaultZone:number;
	private zoneData = new Array<ZoneData>();
	private heatingCircuits=new Array<HeatingCircuit>();
	
	// zahlenwerte, die mit bestimmter schrittweite in einem bestimmten bereich liegen.
	scales:Map<string,BaseSensor>;
	constructor(){

		super(0);
		this._hooks = new SimulatorHooks(this);
		this.states = new Map<string,string>();
		this.modes = new Map<string,string>();
		this.scales = new Map<string,BaseSensor>();
		for(let mode of this.blocking_modes){
			this.setValue(mode,"off");
		}

		/**
			New Wizard-Values.

		**/
		this.setValue('WIZARD_SYSTEM_SCHEME_IS_KNOWN_TO_INSTALLER','WIZARD_SYSTEM_SCHEME_IS_KNOWN_TO_INSTALLER_ENUM_YES');

		this.setValue('solar_buffers_seen','false');
        let wizard_menues = {
            'WIZARD_SYSTEM_SCHEME_IS_KNOWN_TO_INSTALLER':[
                'WIZARD_SYSTEM_SCHEME_IS_KNOWN_TO_INSTALLER_ENUM_YES',
                'WIZARD_SYSTEM_SCHEME_IS_KNOWN_TO_INSTALLER_ENUM_NO'
            ],
            'WIZARD_BOILER_QUESTION_DHW_OPTION_TITLE':[
                'ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_COMBI_BOILER',
                'ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_COMPACT_BOILER',
                'ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_TANK_SENSOR_AT_THE_BOILER',
                'ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_TANK_SENSOR_AT_THE_CONTROL_MODULE',
                'ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_SHIFT_LOADING_TANK',
                'ENUM_WIZARD_BOILER_QUESTION_DHW_OPTION_NO_DHW'
            ],
            'WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_TITLE':[
                'ENUM_WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_DHW_BY_ALL_BOILERS',
                'ENUM_WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_DHW_BY_LAST_BOILER',
                'ENUM_WIZARD_BOILER_QUESTION_DHW_CASCADE_OPTION_NO_DHW'
            ],
            'WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_TITLE':[
                'ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_E_HEATING_IN_DLOW',
                'ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_BOILER',
                'ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_E_HEATING_IN_BUFFER',
                'ENUM_WIZARD_HEATPUMP_QUESTION_BACKUP_HEATER_TYPE_NO_BUH'
            ],
            'WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_TITLE':[
                'ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_AVAILABLE_HEX',
                'ENUM_WIZARD_HEATPUMP_QUESTION_FROST_PROTECTION_HEX_NO_HEX'
            ],
            'WIZARD_HEATPUMP_QUESTION_POSITION_BUH_TITLE':[
                'ENUM_WIZARD_HEATPUMP_QUESTION_POSITION_BUH_BUH_IN_HEATING_CIRCUIT',
                'ENUM_WIZARD_HEATPUMP_QUESTION_POSITION_BUH_BUH_IN_GLYCOL_WATER'
            ],
            'WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_TITLE':[
                'ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_DHW_IN_HEATING_WATER',
                'ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTION_2_DHW_IN_GLYCOL_WATER'
            ],
            'WIZARD_BOILER_QUESTION_DHW_OPTION_2_TITLE':[
                'ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_HAP_AND_BOILER',
                'ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_DHW_BY_BOILER',
                'WIZARD_ISOLATION_SWITCH_ENUM2',
                'ENUM_WIZARD_HEATPUMP_QUESTION_DHW_OPTIONS_NO_DHW'
            ],
            'WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_TITLE':[
                'ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_WITH_DHW_SENSOR',
                'ENUM_WIZARD_HEATPUMP_QUESTION_DHW_SENSOR_POSITION_BOILER_W_O_DHW_SENSOR',
            ]
        };
        let wizard_menues_keys = Object.keys(wizard_menues);
        for(let wizard_menu_key of wizard_menues_keys){
        	console.log("Saving empty "+wizard_menu_key);
        	this.setValue(wizard_menu_key, '');//wizard_menues[wizard_menu_key][0]);
        }

		this.scales.set('recommended_system_scheme_code',BaseSensor.fromArgs("recommended_system_scheme_code",16,0,32,1,""));
		this.setValue('wizard_help_shown','false');
		this.setValue('greeniq','ENUM_GREEN_IQ_ON');
		this.setValue('heizmodus','Zeitgesteuert');
		this.setValue('warmwassermodus','ENUM_DHW_MODE_TIMECONTROLLED');
		this.setValue('lueftungsmodus','ENUM_VENTILATION_MODE_AUTOMATIC');
		this.setValue('kuehlmodus','ENUM_COOLING_MODE_TIMECONTROLLED');
		this.setValue('waermerueckgewinnung','ENUM_HEAT_RECOVERY_AUTO');
		this.setValue('feuchteschutz','Auto');
		this.setValue('remote_connected','unset');
		this.setValue('brenner','ENUM_BURNER_STATE_OFF');
		this.setValue('sommerzeit','ENUM_SUMMER_WINTER_TIME_ADJUSTMENT_MANUAL');
		this.setValue('stromtariftyp','ENUM_ELECTRICITY_TARIFF_TYPE_VARIABLE');
		this.setValue('adaptiveHeatingCurve','ENUM_ADAPTIVE_HEATING_CURVE_DISABLED');
		this.setValue('automatic_cooling','ENUM_AUTOMATIC_COOLING_NO');
		this.setValue('source_regeneration','ENUM_SOURCE_REGENERATION_NO');
		this.setValue('hybridmanager','ENUM_HYBRID_MANAGER_BIVALENCEPOINT');
		this.setValue('evu','ENUM_ENERGY_SUPPLIER_DISABLEHEATANDBACKUP')
		this.setValue('zusatzheizgeraet_modus','ENUM_AUXILIARY_HEATER_FOR_DHWANDHEATING');
		this.setValue('zusatzheizgeraet_typ','ENUM_AUXILIARY_HEATER_TYPE_CONDENSING');
		this.setValue('ext_inputs','ENUM_CONFIGURATION_OF_DEMAND_INPUTS_DISABLE_BY_SHORT_CIRCUIT');
		this.setValue('ansteuerumkehr','ENUM_ACTUATION_REVERSAL_ON');
		this.setValue('configuration_ma_vr70','ENUM_MAVR70_NO_FUNCTION');
		this.setValue('configuration_ma_vr71','ENUM_MAVR71_NO_FUNCTION');
		this.setValue('configuration_ma2','ENUM_HP_MODUL_OUTPUT_2_DHW_CIRCULATION_PUMP');
		this.setValue('configuration_me','ENUM_HP_MODUL_INPUT_ONE_TIME_CIRCULATION_PUMP');	
		this.setValue('configuration_wp_ma2','ENUM_HP_MODUL_OUTPUT_2_DHW_CIRCULATION_PUMP');
		this.setValue('configuration_wp_me','ENUM_HP_MODUL_INPUT_ONE_TIME_CIRCULATION_PUMP');
		
		this.setValue('configuration_wp_regelungsmodul','ENUM_HEAT_GENERATOR_STATUS_STANDBY');
		this.setValue('leistungsreduzierung','ENUM_ELECTRICAL_POWER_LIMITATION_NOT_ACTIVE');
		this.setValue('ANCHOR_STATUS_OF_THE_EVU_CONTACT','ENUM_STATUS_OF_THE_EVU_CONTACT_RELEASED');
		

		// wizard...
		this.setValue('wizard_solar_option','WIZARD_SOLAR_OPTIONS_ENUM1');
		this.setValue('wizard_zone_option','WIZARD_SELECT_CIRCUIT_OPTION_ENUM1');
		this.setValue('wizard_mavr70_options','WIZARD_MA_VR70_OPTIONS_ENUM1');
		this.setValue('wizard_vwz_options','WIZARD_VWZ_OPTIONS_ENUM1');
		this.setValue("brightness_dimmed",'ENUM_DISPLAY_BRIGHTNESS_DIMMED_NORMAL');
		this.setValue("trennschaltung",'ENUM_ISOLATION_SWITCH_OFF');

		this.mainZoneId  = 1;
		this.scales.set('max_preheating_time',BaseSensor.fromArgs("max_preheating_time",0,0,300,10,"STD_UNIT_MINUTES_NORMAL_LEFT"));
		this.scales.get('max_preheating_time').setSpecialValue(0,"ENUM_ALTERNATIVE_POINT_OFF_NORMAL");
		this.scales.set('WIZARD_MAXIMUM_FLOW_TEMPERATURE_FOR_MSS_TITLE',BaseSensor.fromArgs("WIZARD_MAXIMUM_FLOW_TEMPERATURE_FOR_MSS_TITLE",80,80,55,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		
		this.scales.set('continuos_heating',BaseSensor.fromArgs("continuos_heating",-26,-26,10,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.get('continuos_heating').setSpecialValue(-26,"ENUM_ALTERNATIVE_POINT_OFF_NORMAL");

		this.scales.set("connectionQualityVRC720",BaseSensor.fromArgs("connectionQualityVRC720",10,0,10,1," "));
		this.scales.set("connectionQualityATSensor",BaseSensor.fromArgs("connectionQualityVRC720",10,0,10,1," "));
		this.scales.set("brightness",BaseSensor.fromArgs("brightness",10,0,10,1," "));

		this.scales.set("zusatztarif",BaseSensor.fromArgs("zusatztarif",12,1,999,1,""));
		this.scales.set("eintarif",BaseSensor.fromArgs("eintarif",20,1,999,1,""));
		this.scales.set("hochtarif",BaseSensor.fromArgs("hochtarif",20,1,999,1,""));
		this.scales.set("niedertarif",BaseSensor.fromArgs("niedertarif",16,1,999,1,""));
		this.scales.set("code",BaseSensor.fromArgs("code",0,0,99,1,""));

		this.scales.set("automatic_cooling_temperature_outside",BaseSensor.fromArgs("automatic_cooling_temperature_outside",15,10,30,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("dew_point",BaseSensor.fromArgs("dew_point",-30,4,30,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("bivalence_point_water",BaseSensor.fromArgs("bivalence_point_water",-7,-20,50,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("bivalence_point_heating",BaseSensor.fromArgs("bivalence_point_heating",-5,-20,30,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("alternative_point",BaseSensor.fromArgs("alternative_point",-21,-21,40,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.get('alternative_point').setSpecialValue(-21,"ENUM_ALTERNATIVE_POINT_OFF_NORMAL");
		this.scales.set("alternative_point_ch",BaseSensor.fromArgs("alternative_point_ch",-21,-21,40,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.get('alternative_point_ch').setSpecialValue(-21,"ENUM_ALTERNATIVE_POINT_OFF_NORMAL");
		this.scales.set("alternative_point_dhw",BaseSensor.fromArgs("alternative_point_dhw",-21,-21,40,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.get('alternative_point_dhw').setSpecialValue(-21,"ENUM_ALTERNATIVE_POINT_OFF_NORMAL");
		
		this.scales.set("ANCHOR_LIMIT_OF_FLOW_TEMPERATURE_CORRECTION",BaseSensor.fromArgs("ANCHOR_LIMIT_OF_FLOW_TEMPERATURE_CORRECTION",20,0,20,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		
		this.scales.set("temperature_emergency_run",BaseSensor.fromArgs("temperature_emergency_run",25,20,80,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("inlet_temperature",BaseSensor.fromArgs("inlet_temperature",35,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("offset_bufferstorage",BaseSensor.fromArgs("offset_bufferstorage",10,0,15,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.scales.set("systemschema_code",BaseSensor.fromArgs("systemschema_code",8,1,16,1,""));
		this.scales.set("configuration_vr70",BaseSensor.fromArgs("configuration_vr70",1,1,12,1,""));
		this.scales.set("configuration_vr71",BaseSensor.fromArgs("configuration_vr71",1,1,11,1,""));

		// 3.5.13
		this.scales.set("buffertemperature_top",BaseSensor.fromArgs("buffertemperature_top",12,1,12,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("buffertemperature_bottom",BaseSensor.fromArgs("buffertemperature_bottom",12,1,12,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("temp_sensor_ww_top",BaseSensor.fromArgs("temp_sensor_ww_top",12,1,12,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("temp_sensor_ww_bottom",BaseSensor.fromArgs("temp_sensor_ww_bottom",12,1,12,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("temp_sensor_hz_bottom",BaseSensor.fromArgs("temp_sensor_hz_bottom",12,1,12,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("temp_sensor_hz_top",BaseSensor.fromArgs("temp_sensor_hz_top",12,1,12,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("solar_buffer_count",BaseSensor.fromArgs("solar_buffer_count",1,1,2,1,""));
		this.scales.set("solarbuffer_1_bottom",BaseSensor.fromArgs("solarbuffer_1_bottom",12,1,12,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("solarbuffer_2_bottom",BaseSensor.fromArgs("solarbuffer_2_bottom",12,1,12,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("max_ww_inlet_nominal",BaseSensor.fromArgs("max_ww_inlet_nominal",60,45,80,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("max_temp_buffer_1",BaseSensor.fromArgs("max_temp_buffer_1",75,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("max_temp_buffer_2",BaseSensor.fromArgs("max_temp_buffer_2",75,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));

		//3.5.14
		this.scales.set("solar_collector_temperature",BaseSensor.fromArgs("solar_collector_temperature",85,0,200,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.setValue('solar_pump_state','ENUM_SOLAR_PUMP_STATUS_OFF');
		this.setValue('solar_pump_kick','ENUM_COLLECTOR_KICK_FUNCTION_ON');
		this.scales.set("solar_gain",BaseSensor.fromArgs("solar_gain",78,0,200,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("solar_throughput",BaseSensor.fromArgs("solar_throughput",0.0,0.0,165,0.1,"STD_UNIT_LITER_PRO_MINUTE_NORMAL_LEFT"));
		this.scales.get("solar_throughput").setSpecialValue(0.0,"ENUM_SOLAR_FLOW_RATE_AUTO_NORMAL");
		this.scales.set("solar_protection",BaseSensor.fromArgs("solar_protection",130,110,150,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("solar_min_collector_temp",BaseSensor.fromArgs("solar_min_collector_temp",20,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("solar_ventilation_time",BaseSensor.fromArgs("solar_ventilation_time",0,0,600,1,"STD_UNIT_MINUTES_NORMAL_LEFT"));
		this.scales.set("solar_current_throughput",BaseSensor.fromArgs("solar_current_throughput",0,0,16.5,0.1,"STD_UNIT_LITER_PRO_MINUTE_NORMAL_LEFT"));
		this.scales.set("solarbuffer_1_einschaltdifferenz",BaseSensor.fromArgs("solarbuffer_1_einschaltdifferenz",12,2,25,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.scales.set("solarbuffer_2_einschaltdifferenz",BaseSensor.fromArgs("solarbuffer_2_einschaltdifferenz",12,2,25,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.scales.set("solarbuffer_1_ausschaltdifferenz",BaseSensor.fromArgs("solarbuffer_1_ausschaltdifferenz",5,1,20,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.scales.set("solarbuffer_2_ausschaltdifferenz",BaseSensor.fromArgs("solarbuffer_2_ausschaltdifferenz",5,1,20,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.scales.set("solarbuffer_1_max_temp",BaseSensor.fromArgs("solarbuffer_1_max_temp",75,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("solarbuffer_2_max_temp",BaseSensor.fromArgs("solarbuffer_2_max_temp",75,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));

		// 3.5.16
		this.scales.set("td_regelung_einschaltdifferenz",BaseSensor.fromArgs("td_regelung_einschaltdifferenz",12,2,25,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		this.scales.set("td_regelung_ausschaltdifferenz",BaseSensor.fromArgs("td_regelung_ausschaltdifferenz",5,1,20,1,"STD_UNIT_KELVIN_NORMAL_LEFT"));
		
		this.scales.set("td_regelung_min_temp",BaseSensor.fromArgs("td_regelung_min_temp",0,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("td_regelung_max_temp",BaseSensor.fromArgs("td_regelung_max_temp",99,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("td_sensor_1",BaseSensor.fromArgs("td_sensor_1",66,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set("td_sensor_2",BaseSensor.fromArgs("td_sensor_2",72,0,99,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.setValue('td_ausgang','ENUM_TD_OUTPUT_OFF');

		//...
		this.scales.set('estrichttrocknung-tag-0',BaseSensor.fromArgs('estrichttrocknung-tag-0',0,0,0,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-1',BaseSensor.fromArgs('estrichttrocknung-tag-1',25,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-2',BaseSensor.fromArgs('estrichttrocknung-tag-2',30,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-3',BaseSensor.fromArgs('estrichttrocknung-tag-3',35,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-4',BaseSensor.fromArgs('estrichttrocknung-tag-4',40,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-5',BaseSensor.fromArgs('estrichttrocknung-tag-5',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-6',BaseSensor.fromArgs('estrichttrocknung-tag-6',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-7',BaseSensor.fromArgs('estrichttrocknung-tag-7',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-8',BaseSensor.fromArgs('estrichttrocknung-tag-8',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-9',BaseSensor.fromArgs('estrichttrocknung-tag-9',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));

		this.scales.set('estrichttrocknung-tag-10',BaseSensor.fromArgs('estrichttrocknung-tag-10',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-11',BaseSensor.fromArgs('estrichttrocknung-tag-11',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-12',BaseSensor.fromArgs('estrichttrocknung-tag-12',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-13',BaseSensor.fromArgs('estrichttrocknung-tag-13',40,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-14',BaseSensor.fromArgs('estrichttrocknung-tag-14',35,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-15',BaseSensor.fromArgs('estrichttrocknung-tag-15',25,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-16',BaseSensor.fromArgs('estrichttrocknung-tag-16',25,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-17',BaseSensor.fromArgs('estrichttrocknung-tag-17',10,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-18',BaseSensor.fromArgs('estrichttrocknung-tag-18',10,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-19',BaseSensor.fromArgs('estrichttrocknung-tag-19',10,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));

		this.scales.set('estrichttrocknung-tag-20',BaseSensor.fromArgs('estrichttrocknung-tag-20',10,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-21',BaseSensor.fromArgs('estrichttrocknung-tag-21',10,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-22',BaseSensor.fromArgs('estrichttrocknung-tag-22',10,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-23',BaseSensor.fromArgs('estrichttrocknung-tag-23',10,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-24',BaseSensor.fromArgs('estrichttrocknung-tag-24',30,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-25',BaseSensor.fromArgs('estrichttrocknung-tag-25',35,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-26',BaseSensor.fromArgs('estrichttrocknung-tag-26',40,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-27',BaseSensor.fromArgs('estrichttrocknung-tag-27',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-28',BaseSensor.fromArgs('estrichttrocknung-tag-28',35,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('estrichttrocknung-tag-29',BaseSensor.fromArgs('estrichttrocknung-tag-29',25,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));

		this.values.set('actortest_actor','Kein Aktor');
		this.scales.set('s1',BaseSensor.fromArgs('s1',59,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s2',BaseSensor.fromArgs('s2',55,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s3',BaseSensor.fromArgs('s3',48,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s4',BaseSensor.fromArgs('s4',45,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s5',BaseSensor.fromArgs('s5',53,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s6',BaseSensor.fromArgs('s6',42,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s7',BaseSensor.fromArgs('s7',51,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s8',BaseSensor.fromArgs('s8',43,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s9',BaseSensor.fromArgs('s9',47,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s10',BaseSensor.fromArgs('s10',43,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.scales.set('s11',BaseSensor.fromArgs('s11',50,0,90,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
		this.setZoneCount(3);
		this.setHeatingCircuitCount(3);
	}
	simulatorConfig:SimulatorConfig;
	setSimulatorConfig(sc:SimulatorConfig){
		this._hooks.setSimulatorConfig(sc);
		this.simulatorConfig = sc;
		let maxHeatingCircuitCount = 9;
		if(this.simulatorConfig.getVR71Count() == 1 && this.simulatorConfig.getVR70Count() == 0){
			maxHeatingCircuitCount = 3;
		}
		if(this.simulatorConfig.getVR71Count() == 1 && this.simulatorConfig.getVR70Count() == 1){
			maxHeatingCircuitCount = 5;
		}
		if(this.simulatorConfig.getVR71Count() == 1 && this.simulatorConfig.getVR70Count() == 2){
			maxHeatingCircuitCount = 7;
		}
		if(this.simulatorConfig.getVR71Count() == 1 && this.simulatorConfig.getVR70Count() == 3){
			maxHeatingCircuitCount = 9;
		}
		if(this.simulatorConfig.getVR70Count() == 1 && this.simulatorConfig.getVR71Count() == 0){
			maxHeatingCircuitCount = 2;
		}
		
		this.scales.set("wizard_heatingcircuit_count",BaseSensor.fromArgs("wizard_heatingcircuit_count",1,1,maxHeatingCircuitCount,1,""));

	}
	getSimulatorConfig(){
		return this.simulatorConfig;
	}
	mainZoneId: number = 1;
	getDefinedBlockingStates(){
		return this.blocking_modes;
	}
	isInBlockingMode(){
		for(let m of this.blocking_modes){
			if(this.getValue(m) == "on"){
				return true;
			}
		}
		return false;
	}

	getBlockingStates():Array<string>{
		let states = new Array<string>();
		for(let m of this.blocking_modes){
			if(this.getValue(m) == "on"){
				states.push(m);
			}
		}

		return states;
	}

	reset(){
		this.disableBlockingStates();
	}
	public disableBlockingStates():void{
		for(let m of this.blocking_modes){
			this.setValue(m,"off");
		}
	}
	blocking_modes=['cylinder_boost','ventilation_boost','system_off','absence'];

	getDeviceList():Array<KeyValuePair>{
		let list = Array<KeyValuePair>()
		list.push(new KeyValuePair('Regler','01.18'));
		list.push(new KeyValuePair('Wärmepumpe','03.04'));
		list.push(new KeyValuePair('WP-Regelungsmodul','03.04'));
		list.push(new KeyValuePair('VR70, Adresse 1','01.06'));
		return list;
	}

	setHeatpumpCount(val:number):void{

		for(let i=0;i<this.heatpumpCount;i++){
			let idx="heatpump-inlet-temperature-"+(i+1).toString();
			this.scales.delete(idx);
		}
		this.heatpumpCount=val;

		for(let i=0;i<this.heatpumpCount;i++){
			let idx="heatpump-inlet-temperature-"+(i+1).toString();
			this.scales.set(idx,BaseSensor.fromArgs("idx",55,0,80,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
			this.debug("Adding status: "+'heatpump-'+(i+1).toString()+'-mode');
			this.setValue('heatpump-'+(i+1).toString()+'-mode','ENUM_HEAT_GENERATOR_STATUS_STANDBY');
		}
	}
	setBoilerCount(val:number){
		for(let i=0;i<this.heatpumpCount;i++){
			let idx="boiler-inlet-temperature-"+(i+1).toString();
			this.scales.delete(idx);
		}
		this.heatpumpCount=val;

		for(let i=0;i<this.heatpumpCount;i++){
			let idx="boiler-inlet-temperature-"+(i+1).toString();
			this.scales.set(idx,BaseSensor.fromArgs("idx",55,0,80,1,"STD_UNIT_CELSIUS_NORMAL_LEFT"));
			this.debug("Adding status: "+'boiler-'+(i+1).toString()+'-mode');
			this.setValue('boiler-'+(i+1).toString()+'-mode','ENUM_HEAT_GENERATOR_STATUS_STANDBY');
		}
	}
	getConfiguredHeatpumpCount(){
		if(!this.simulatorConfig){
			this.debug("configured HEATPUMPS: 0");
			return 0;
		}
		this.debug("configured HEATPUMPS: "+this.simulatorConfig.heatpumpCount());
		return this.simulatorConfig.heatpumpCount();
	}
	getConfiguredBoilerCount(){
		if(!this.simulatorConfig){
			return 0;
		}
		return this.simulatorConfig.boilerCount();

	}
	getHeatpumpCount():number{
		return this.heatpumpCount;
	}
	getHeatingCircuit(idx:number):HeatingCircuit{
		return this.heatingCircuits[idx];
	}
	getDefaultHeatingCircuit(){
		return this.getHeatingCircuitById(this.defaultZone);
	}
	getHeatingCircuitById(id:number){
		
		for(let hc of this.heatingCircuits){
			if(hc.getId() == id){

				return hc;
			}else{
				//console.log("not returning hc "+hc.getId() );
			}
		}
		return null;
	}
	getBoilerCount(){
		if(!this.simulatorConfig){
			return 0;
		}
		return this.simulatorConfig.boilerCount();
	}
	getHeatGeneratorCount(){
		if(!this.simulatorConfig){
			return 0;
		}
		let hcc = this.simulatorConfig.heatpumpCount();
		let bc = this.simulatorConfig.boilerCount();
		if(bc > hcc){
			this.debug("Heat generators: "+bc);
			return bc;
		}else{
			this.debug("Heat generators: "+hcc);
			return hcc;
		}
	}
	getHeatingCircuits():Array<HeatingCircuit>{
		return this.heatingCircuits;
	}
	getHeatingCircuitCount(){
		return this.heatingCircuits.length;
	}

	getNominalTemperatureSensor(date:Date) : ISensorInterface{
		let zone = this.getDefaultZone();
		if(zone.getRawValue('quickset-temperature-enabled')=='on'){
			return zone.getSensor('temperature','room_temperature_nominal_quick');
		}
		switch(zone.getRawValue('heatingmode')){
			case 'ENUM_HEATING_MODE_OFF':{
				return null;
			}
			case 'ENUM_HEATING_MODE_MANUAL':{
				return zone.getSensor('temperature','room_temperature_nominal');
			}
			case 'ENUM_HEATING_MODE_TIMECONTROLLED':{
				let timeframeManager = zone.getTimeFrameManager('heating');
				if(!timeframeManager){
					this.debug("cannot get timeframe-manager.");
					return;
				}
				let day = date.getDay();

				if(day == 0){
					day = 6;
				}else{
					day = day-1;
				}
				this.debug("Asking for day:" +day);
				let timeframe = timeframeManager.getTimeFrame(day,date);
				if(!timeframe){
					this.debug("cannot get timeframe");
					return;
				}
				let sensor = timeframe.getSensor();
				if(!sensor){
					this.debug("cannot get sensor.");
				}
				this.debug("Found Timeframe sensor: "+timeframe.toString());
				return sensor;
			}
			default:{
				return zone.getSensor('temperature','room_temperature_nominal');	
			}
		}


	}
	setHeatingCircuitCount(val:number){
		this.heatingCircuits.length = 0;
		for(let i=0;i<val;i++){
			this.heatingCircuits.push(new HeatingCircuit(i+1));
		}
		
		//this.getScale('wizard_heatingcircuit_count').setCurrentValue(val);
	}

	
	getHeatingCircuitIds():Array<number>{

    	let ids = [];
    	for(let hc of this.heatingCircuits){
      		ids.push(hc.getId());
    	}
    	return ids;
	}



	setZoneCount(zc:number){
		this.zoneData.length = 0;
		let activeHeatingCircuitCount = zc;
		if(!this.simulatorConfig){
			return;
		}
		if(this.simulatorConfig){
			console.log("Overwriting activeHeatingCircuitCount with "+this.simulatorConfig.activeHeatingCircuits());
			activeHeatingCircuitCount = this.simulatorConfig.activeHeatingCircuits();
		}


		//Zuordnungen / Fernbedienungen

		if(this.simulatorConfig.hasVR71()){
			for(let i=1;i<=zc;i++){
				let zd = new ZoneData(TranslationService.getInstance().tr("ANCHOR_ZONE")+ " "+i,i);
				if(i <= 5){
					if(i < zc && i < 5){
						zd.setValue('zone_assignment','ENUM_ZONE_BINDING_REMOTE_CONTROL_'+i.toString());
					}

					if(i == activeHeatingCircuitCount){
						zd.setValue('zone_assignment','ENUM_ZONE_BINDING_CENTRAL_CONTROL');
					}

				}
				if(i > 5 || i > activeHeatingCircuitCount){
					zd.setValue('zone_assignment','ENUM_ZONE_BINDING_NO');
				}

				this.zoneData.push(zd);

			}
		}else{
			for(let i=1;i<=zc;i++){
				let zd = new ZoneData(TranslationService.getInstance().tr("ANCHOR_ZONE")+ " "+i,i);
				if(i == 1){
					zd.setValue('zone_assignment','ENUM_ZONE_BINDING_CENTRAL_CONTROL');
				}else{
					zd.setValue('zone_assignment','ENUM_ZONE_BINDING_NO');
				}
				this.zoneData.push(zd);
			}
		}

		if(this.defaultZone == undefined){
			this.defaultZone = 1;
		}
  	}

  getZoneCount():number{
  	return this.zoneData.length;
  }
  
  getDefaultZoneId():number{
    return this.getControlledZoneId()??this.defaultZone;
  }
  
  setDefaultZoneId(val:number):void{
  	this.defaultZone = val;
  }
  
  getDefaultZone():ZoneData{
  	return this.getZoneById(this.getDefaultZoneId());
  }

  getZone():ZoneData{
    return this.getZoneById(this.getDefaultZoneId());
  }
  getZoneById(id:number):ZoneData{

    for(let zd of this.zoneData){
      if(zd.getId() == id){
        return zd;
      }else{
      }
    }
  }



  getZoneByIndex(zone:number):ZoneData{
    return this.zoneData[zone];
  }

  getZoneIds(){
    this.debug("Getting Zone-IDs");
    let ids = [];
    for(let zone of this.zoneData){
      ids.push(zone.getId());
    }
    this.debug(JSON.stringify(ids));
    return ids;
  }
  getVR71Count(){
  	return this.simulatorConfig.getVR71Count();
  }
  getVR70Count(){
  	return this.simulatorConfig.getVR70Count();
  }
  

  getHooks(){
  	return this._hooks;
  }
  

  system_scheme():number{
  	return this.scales.get('systemschema_code').getCurrentValue();
  }
	vr70():number{
		return this.scales.get("configuration_vr70").getCurrentValue();
	}
	vr71():number{
		return this.scales.get("configuration_vr71").getCurrentValue();
	}
}

